import { Box, Button, Card, CardContent, CardHeader, TextField, Typography, Divider, Alert, Link as MuiLink } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";

export default function LoginPage() {
  const theme = useTheme();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setErrMsg(null);
      const res = await api.post("/auth/login", { email, password });
      login(res.data.token, res.data.role);
      window.location.href = "/";
    } catch (e: any) {
      const msg = e?.response?.data?.message || "Invalid credentials";
      setErrMsg(msg);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        px: 6,
        py: 12,
        backgroundColor: theme.palette.background.default,
        backgroundImage:
          theme.palette.mode === "dark"
            ? "radial-gradient(1200px 600px at 100% -10%, rgba(37,99,235,0.08), transparent),radial-gradient(1000px 500px at -10% 110%, rgba(34,211,238,0.05), transparent)"
            : "radial-gradient(1200px 600px at 100% -10%, rgba(37,99,235,0.06), transparent),radial-gradient(1000px 500px at -10% 110%, rgba(34,211,238,0.04), transparent)",
      }}
    >
      <Card
        sx={{
          maxWidth: 500,
          width: "100%",
          paddingY: 4,
          paddingX: { xs: 3, md: 6 },
          boxShadow: 10,
          borderRadius: 4,
        }}
      >
        <CardHeader
          disableTypography
          title={
            <Typography
              variant="h4"
              align="center"
              sx={{ fontWeight: "bold", color: theme.palette.primary.light, mb: 1 }}
            >
              Welcome to RepairSync
            </Typography>
          }
          subheader={
            <Typography
              align="center"
              variant="body1"
              sx={{ color: "text.secondary" }}
            >
              Your All-in-One Repair Shop Management Suite
            </Typography>
          }
        />
        <Divider sx={{ my: 2 }} />
        <CardContent>
          {errMsg && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errMsg} {String(errMsg).toLowerCase().includes('verify') && (
                <>
                  {" "}Didn’t get the email? {" "}
                  <MuiLink href="/verify" underline="hover">Resend verification</MuiLink>
                </>
              )}
            </Alert>
          )}
          <form onSubmit={handleSubmit} className="space-y-5">
            <TextField
              label="Email Address"
              variant="outlined"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Typography variant="body2" align="right">
              <a href="/forgot-password" className="text-blue-700 hover:underline">Forgot password?</a>
            </Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ fontWeight: "bold", py: 1.5 }}
            >
              Login
            </Button>
          </form>

          <Typography variant="body2" align="center" sx={{ mt: 3 }}>
            New Shop?{" "}
            <a
              href="/signup"
              className="text-blue-700 font-semibold hover:underline"
            >
              Register Here
            </a>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
